import React from "react";
import { Switch, Route } from "react-router-dom";
import EmbedDashboard from "./EmbedDashboard";

const EmbedApp = () => {
  return (
    <div style={{ height: "100vh", width: "100vw", overflow: "auto" }}>
      <Switch>
        <Route exact path="/embed/dashboard" component={EmbedDashboard} />
      </Switch>
    </div>
  );
};

export default EmbedApp;
